/**
 * Route guard that redirects to /login when there's no authenticated MSAL
 * account. UI-only — the backend re-checks every request (CLAUDE.md §5.3 —
 * no client-trusted authorisation).
 */

import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

export function RequireAuth({ children }: PropsWithChildren) {
  const { accounts } = useMsal();
  if (accounts.length === 0) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
